import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ShowAgroambientalGuardService {

  
    constructor(public router: Router) {}

    canActivate(): boolean | UrlTree {

        if (!environment.features.showTareasAgroambiental) {
            return this.router.parseUrl('/login');
        }

        return true;
    }
}
